import { createModal } from "./coreModal.js";
import Splide from "@splidejs/splide";

export function openSliderModal({ trigger }) {
  const modal = createModal({ modifier: "l-modal--slider" });
  if (!modal) return;

  console.log(trigger);

  // グループ取得
  const group = trigger.dataset.modalGroup;
  if (!group) {
    console.warn("data-modal-group がありません");
    return;
  }

  // 同じグループの画像を全部取得
  const triggers = document.querySelectorAll(`[data-modal-group="${group}"]`);

  if (!triggers.length) return;

  // クリックされた index を探す
  let startIndex = 0;
  triggers.forEach((el, i) => {
    if (el === trigger) startIndex = i;
  });

  // === DOM生成 ===
  const splideEl = document.createElement("div");
  splideEl.className = "splide";

  splideEl.innerHTML = `
    <div class="splide__track">
      <ul class="splide__list"></ul>
    </div>
  `;

  const list = splideEl.querySelector(".splide__list");

  triggers.forEach((el) => {
    const src = el.getAttribute("href");
    if (!src) return;

    const li = document.createElement("li");
    li.className = "splide__slide";
    li.innerHTML = `<img src="${src}" alt="">`;
    list.appendChild(li);
  });

  modal.body.appendChild(splideEl);

  // === Splide mount ===
  const splide = new Splide(splideEl, {
    type: "fade",
    rewind: true,
    pagination: false,
    arrows: triggers.length > 1,
    start: startIndex,
  });

  requestAnimationFrame(() => {
    splide.mount();
  });

  // close処理
  const originalClose = modal.close;
  modal.close = () => {
    splide.destroy(true);
    originalClose();
  };
}
